export default __webpack_public_path__ + "static/media/img11.7a5c3f82.jpg";